import { Button as ChakraButton } from '@chakra-ui/react'
import { FiPlusCircle } from 'react-icons/fi'

export function Button({ children, ...rest }) {
  return (
    <ChakraButton
      borderRadius="0"
      bgColor="transparent"
      color="#2D2D2D"
      fontSize="15px"
      border="1px solid #378BBF"
      leftIcon={
        <FiPlusCircle
          color={rest.iconColor ? rest.iconColor : '378BBF'}
          size={25}
        />
      }
      {...rest}
    >
      {children}
    </ChakraButton>
  )
}
